import * as React from "react";
import type { SVGProps } from "react";
const SvgCoinProtectIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="coin_protect_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M840.619 254.976c8.277 2.133 12.8 9.088 12.714 15.573-.981 105.728-12.885 245.888-51.114 332.544-63.147 143.104-181.632 193.878-255.232 224.512l-1.579.683c-10.752 4.437-23.125 9.6-33.408 14.677l-14.336-7.381h-.043c-71.21-36.48-193.834-100.395-273.322-232.832-21.931-36.565-35.2-92.8-43.051-153.43-7.85-60.586-10.24-125.397-10.581-178.773a16.299 16.299 0 0 1 12.714-15.573l319.062-83.072a37.973 37.973 0 0 1 19.114 0l319.062 83.072zm-329.6 683.69 38.485-19.029c7.808-3.84 18.133-8.149 30.293-13.226 75.35-31.403 222.806-92.843 300.502-268.886 45.909-104.106 57.386-259.84 58.368-366.208a101.547 101.547 0 0 0-76.544-98.901L543.06 89.301a123.307 123.307 0 0 0-62.122 0l-319.062 83.115a101.632 101.632 0 0 0-76.544 98.688c.342 55.04 2.816 123.69 11.307 189.184 8.107 62.677 22.997 133.845 54.485 186.368C244.14 801.664 386.86 874.709 458.752 911.531l14.208 7.296 38.059 19.84zm-41.686-256a42.667 42.667 0 1 0 85.334 0 42.667 42.667 0 1 0-85.334 0Zm42.667-384a42.667 42.667 0 0 1 42.667 42.667v213.334a42.667 42.667 0 1 1-85.334 0V341.333A42.667 42.667 0 0 1 512 298.667z"
    />
  </svg>
);
export default SvgCoinProtectIcon;
